import { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic'
import { useMutation, useQueryClient } from 'react-query'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { FS } from '@dc-shared-web/lib/trackingConstants'
import {
  renameFolderNew,
  RenameFolderParamsNew,
} from '@dc-shared-web/hooks/api/folder/renameFolder'
import { useToast } from '@dc-shared-web/components'

export const useRenameFolder = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { trackEvent } = useFSTrackEvent()

  return useMutation(
    (mutationParams: RenameFolderParamsNew) =>
      renameFolderNew(apiClient, mutationParams),
    {
      onSuccess: async (_, context) => {
        trackEvent(FS.FOLDER_RENAMED)

        await queryClient.invalidateQueries(['folder'])
        await queryClient.invalidateQueries(['project'])
        await queryClient.invalidateQueries(['foldersList'])
        await queryClient.invalidateQueries(['folders'])
        await queryClient.invalidateQueries(['FolderForMove'])
        await queryClient.invalidateQueries(['FolderForMoveTree'])

        toast({
          variant: 'success',
          title: 'Folder renamed',
          description: `${context.oldFolderName} renamed to ${context.newFolderName}.`,
        })
        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error renaming folder',
          description: 'If the issue persists, please contact support.',
        })
        params?.onError?.()
      },
    }
  )
}
